import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'

export const StyledToast = styled(ToastContainer).attrs({})``
